"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRooted = exports.isPrefixed = exports.toOpenApi = exports.ROOTS = exports.API_PREFIX = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const Compose = __importStar(require("./compose"));
const Model = __importStar(require("./model"));
const Order = __importStar(require("./order"));
const Security = __importStar(require("./security"));
exports.NAMESPACE = 'Culligan.Api.OpenApi.Generate';
/** Where the Unified API mounts every router (`HTTP_API_BASE_URL`). */
exports.API_PREFIX = '/api';
/** Every documented path must start with one of these. */
exports.ROOTS = ['/api/v1', '/api/v2'];
/**
 * Converts a composed API root into an OpenAPI 3.1 document.
 *
 * Specification only: this never touches `HttpApiBuilder`, so a root made of
 * documentation-only legacy contracts converts without any handler.
 *
 * The `/api` prefix and the application version are applied here and nowhere
 * else. A root that was already prefixed is rejected rather than documented
 * at `/api/api/...`.
 *
 * Groups are delivered independently, so the root is also rejected when two
 * of them declare the same operation, or emit path templates that differ only
 * in parameter names: `OpenApi.fromApi` would silently keep one operation, or
 * produce two path items OpenAPI treats as the same path.
 *
 * Every endpoint must either carry a security middleware or be marked
 * `Security.Public`: an endpoint with neither would be documented as open,
 * which is indistinguishable from a forgotten guard mirror.
 */
const toOpenApi = (api, options) => {
    if (options.version.trim().length === 0) {
        throw new Error(`${exports.NAMESPACE}: an application version is required`);
    }
    assertNotPrefixed(api);
    assertUniqueOperations(api);
    assertGuarded(api);
    const spec = platform_1.OpenApi.fromApi(api.prefix(exports.API_PREFIX).annotate(platform_1.OpenApi.Version, options.version), options.additionalPropertiesStrategy === undefined
        ? undefined
        : { additionalPropertiesStrategy: options.additionalPropertiesStrategy });
    expandIdentifiedParameterSchemas(api, spec, options);
    assertRooted(spec);
    assertUnambiguousPaths(spec);
    return spec;
};
exports.toOpenApi = toOpenApi;
/**
 * Effect emits an identified schema as a top-level `$ref`, but its OpenAPI
 * parameter generator only expands schemas that directly expose `properties`.
 * Re-expand every parameter source without its top-level reference and append
 * fields that Effect omitted. This covers path/query/header structs while
 * preserving parameters added by endpoint transforms.
 */
const expandIdentifiedParameterSchemas = (api, spec, options) => {
    const operations = operationsById(spec);
    for (const [group, endpoint] of Compose.endpoints(api)) {
        const operation = operations.get(Compose.operationIdOf(group, endpoint));
        if (operation === undefined)
            continue;
        for (const [schema, location] of parameterSources(endpoint)) {
            appendParameters(schema, location, operation, spec, options);
        }
    }
};
/** Every generated operation, keyed by the `operationId` it was emitted under. */
const operationsById = (spec) => new Map(Object.values(spec.paths)
    .flatMap(item => Object.values(item))
    .filter(operation => operation !== undefined)
    .map(operation => [operation.operationId, operation]));
/** The request schemas Effect turns into parameters, in the order it reads them. */
const parameterSources = (endpoint) => {
    const schemas = Model.parameterSchemasOf(endpoint);
    return [
        [schemas.pathSchema, 'path'],
        // A method with a body takes its payload from the body, not the query.
        ...(platform_1.HttpMethod.hasBody(endpoint.method) ? [] : [[schemas.payloadSchema, 'query']]),
        [schemas.headersSchema, 'header'],
        [schemas.urlParamsSchema, 'query'],
    ];
};
const appendParameters = (schema, location, operation, spec, options) => {
    if (effect_1.Option.isNone(schema))
        return;
    const jsonSchema = platform_1.OpenApiJsonSchema.makeWithDefs(schema.value, {
        defs: spec.components.schemas,
        defsPath: '#/components/schemas/',
        topLevelReferenceStrategy: 'skip',
        additionalPropertiesStrategy: options.additionalPropertiesStrategy ?? 'strict',
    });
    if (!('properties' in jsonSchema))
        return;
    for (const [name, parameterSchema] of Object.entries(jsonSchema.properties)) {
        if (operation.parameters.some(parameter => parameter.in === location && parameter.name === name)) {
            continue;
        }
        operation.parameters.push({
            name,
            in: location,
            schema: parameterSchema,
            required: jsonSchema.required.includes(name),
            ...(parameterSchema.description === undefined
                ? undefined
                : { description: parameterSchema.description }),
        });
    }
};
/** Whether a path already carries the `/api` prefix. */
const isPrefixed = (path) => path === exports.API_PREFIX || path.startsWith(`${exports.API_PREFIX}/`);
exports.isPrefixed = isPrefixed;
/** Whether a generated path is rooted at one of the supported versions. */
const isRooted = (path) => exports.ROOTS.some(root => path === root || path.startsWith(`${root}/`));
exports.isRooted = isRooted;
const assertNotPrefixed = (api) => {
    for (const group of Object.values(api.groups)) {
        for (const endpoint of Object.values(group.endpoints)) {
            if ((0, exports.isPrefixed)(endpoint.path)) {
                throw new Error(`${exports.NAMESPACE}: "${endpoint.method} ${endpoint.path}" already carries the ${exports.API_PREFIX} prefix; ` +
                    'the prefix is applied by toOpenApi and must not be part of the spec');
            }
        }
    }
};
const assertUniqueOperations = (api) => {
    const duplicates = Compose.duplicateOperations(api);
    if (duplicates.length > 0) {
        throw new Error(`${exports.NAMESPACE}: operations declared more than once (parameter names do not distinguish paths): ` +
            duplicates.join(', '));
    }
};
const assertGuarded = (api) => {
    const open = Security.unguarded(api);
    if (open.length > 0) {
        throw new Error(`${exports.NAMESPACE}: operations without a security middleware or Security.Public ` +
            `(a missing guard mirror would document a protected route as open): ${open.join(', ')}`);
    }
};
const assertRooted = (spec) => {
    const stray = Object.keys(spec.paths).filter(path => !(0, exports.isRooted)(path));
    if (stray.length > 0) {
        throw new Error(`${exports.NAMESPACE}: paths must be rooted at ${exports.ROOTS.join(' or ')}; found ${stray.join(', ')}`);
    }
};
/**
 * OpenAPI keys path items by template and forbids two templates that differ
 * only in parameter names, regardless of method: `/rules/{ruleId}` and
 * `/rules/{id}` are the same path and must be one path item.
 */
const assertUnambiguousPaths = (spec) => {
    const byShape = new Map();
    for (const path of Object.keys(spec.paths)) {
        const shape = Compose.pathShape(path);
        byShape.set(shape, [...(byShape.get(shape) ?? []), path]);
    }
    const ambiguous = Array.from(byShape.values())
        .filter(paths => paths.length > 1)
        .map(paths => Order.sorted(paths).join(' = '));
    if (ambiguous.length > 0) {
        throw new Error(`${exports.NAMESPACE}: path templates differ only in parameter names and are the same OpenAPI path; ` +
            `align the names: ${ambiguous.join('; ')}`);
    }
};
//# sourceMappingURL=generate.js.map